import React, { useEffect, useState } from 'react';
import MaskReal from 'services/formateRS';

//core components
import Button from "components/CustomButtons/Button.js";
import Snackbar from "components/Snackbar/Snackbar.js";
import useAuth from "hooks/useAuth"
import api from "assets/services/api";

//bootstrap imports
import { Modal, Form, Col } from "react-bootstrap";
import 'bootstrap/dist/css/bootstrap.min.css';

//material compenents
import AddAlert from "@material-ui/icons/AddAlert";



function ModalUpdateOrder(props) {
    const [br, setBR] = useState(false);
    const [amount, setAmount] = useState(props.props.amount);
    const [price_of_product, setPrice_of_product] = useState(props.props.price);

    const { storageId, user } = useAuth();
    const [controlSnack, setControlSnack] = useState(false);


    const showNotification = place => {
        switch (place) {
            case "br":
                if (!br) {
                    setBR(true);
                    setTimeout(function () {
                        setBR(false);
                        setControlSnack(false);
                    }, 6000);
                }
                break;
            default:
                break;
        }
    };

    useEffect(() => {
        if (controlSnack) showNotification("br")
    }, [controlSnack]);

    async function handleEditOrder(e) {
        e.preventDefault();
        const response = await api.put('/order/' + props.props.id, {
            amount,
            price_of_product,
            id_admin: user.id_admin,
            id_product: props.props.id_product
        });
        if (response.data.error) {
            return alert(response.data.error);
        }
        props.loadOrders();
        props.onHide();
    }

    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    Editar produto {props.props.name}
                </Modal.Title>
            </Modal.Header>
            <Form onSubmit={handleEditOrder}>
                <Modal.Body>
                    <Form.Row>
                        <Form.Group as={Col} controlId="formGridAmount">
                            <Form.Label>Quantidade</Form.Label>
                            <Form.Control onChange={event => setAmount(event.target.value)} value={amount} type="double" placeholder="Quantidade do produto" />
                        </Form.Group>
                        <Form.Group as={Col} controlId="formGridPriceOfProduct">
                            <Form.Label>Preço praticado</Form.Label>
                            <MaskReal onChange={value => setPrice_of_product(value.replace(',', '.'))} value={price_of_product} />
                        </Form.Group>

                    </Form.Row>
                </Modal.Body>
                <Modal.Footer>
                    <div className="d-flex justify-content-center">
                        <Button color="success" type="submit">
                            Editar
                        </Button>
                        <Snackbar
                            place="br"
                            color="success"
                            icon={AddAlert}
                            message="Pedido editado com sucesso"
                            open={br}
                            closeNotification={() => setBR(false)}
                            close
                        />
                    </div>
                </Modal.Footer>
            </Form>
        </Modal>
    );
}

export default ModalUpdateOrder;